import styled from '@emotion/styled';
import { variant } from 'styled-system';
import theme from '../../theme';
import {ComponentPropsWithoutRef} from "react";

interface ButtonProps extends ComponentPropsWithoutRef<"button">{
  variant?: keyof typeof theme.buttons;
  fontScale?: keyof typeof theme.fontScales;
  buttonSize?: keyof typeof theme.buttonSizes;
  color?: keyof typeof theme.colors;
  width?: string;
}

const Button = styled.button<ButtonProps>(({ theme, width, color, disabled }) => [
  {
    display: 'flex',
    fontFamily: theme?.font,
    fontWeight: theme?.buttonFontWeight,
    justifyContent: 'center',
    border: 0,
    borderRadius: theme?.borderRadius,
    cursor: !disabled ? 'pointer' : null,
    width,
    color,
  },
  variant({ variants: { ...theme.buttons } }),
  variant({
    prop: 'fontScale',
    variants: { ...theme.fontScales },
  }),
  variant({
    prop: 'buttonSize',
    variants: { ...theme.buttonSizes },
  }),
  {
    backgroundColor: disabled ? theme?.colors.secondaryFont : null,
    '&:hover': {
      backgroundColor: disabled ? theme?.colors.secondaryFont : null,
    }
  }
]);

Button.defaultProps = {
  type: 'button',
  variant: 'primary',
  buttonSize: 'medium',
  fontScale: 'm',
  width: 'fit-content',
};

export default Button;
